$(() => {
    const cookieName = 'hjaarinConsent'
    let consent = Cookies.get(cookieName);

    if (!consent) {
        let acceptCookiesBtn = <HTMLButtonElement>document.getElementById('acceptCookiesBtn');
        let cookieBar = <HTMLDivElement>document.getElementById('cookieBarId');

        cookieBar.classList.remove("d-none");

        acceptCookiesBtn.addEventListener("click", (event) => {
            let cookie = Cookies.noConflict();
            cookie.set(cookieName, 'ok', { expires: 365 });
            cookieBar.classList.add("d-none");
        });
    }
});